import { PPQN } from "./ppqn";
export const UpdateClockRate = PPQN.fromSignature(1, 384);
